<template>
  <div class="input-container">
    <i v-if="icon1" :class="icon1" class="icon-inline"></i>
    <p class="bash-text">
      <span class="vm">»</span><span class="char hidden md:inline">{{ title1 }}:</span> <span class="value">{{ value1 }}</span>
    </p>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "valueboxEnat",
  setup() {},
  components: {
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    moduleData: {
      type: Object,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    fgColor: {
      type: String,
      required: false
    },
    bgColor: {
      type: null,
      required: false
    },
    badge: {
      type: null,
      required: false
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  watch: {

  },
  computed: {
    title1: function () {
      if (this.title) return this.title;
      return '';
    },
    value1: function () {
      if (this.value) return this.value;
      return '';
    },
    subtitle1: function () {
      if (this.subtitle) return this.subtitle;
      return '';
    },
    icon1: function () {
      if (this.icon) {
        return this.icon;
      }
      return '';
    },
    fgColor1: function () {
      if (this.fgColor) {
        return `fg-${this.fgColor}`;
      }
      return '';
    },
    bgColor1: function () {
      if (this.bgColor) {
        return `bg-${this.bgColor}`;
      }
      return '';
    },
    badge1: function () {
      if (this.badge) {
        return this.badge.toString();
      }
      return null;
    },
    department: function () {
      if (this.moduleData.metadata.department) return this.moduleData.metadata.department;
      else return "";
    },
    label: function () {
      if (this.moduleData.metadata.label) return this.moduleData.metadata.label;
      else return "";
    },
    description: function () {
      if (this.moduleData.metadata.description) return this.moduleData.metadata.description;
      else return "";
    }
  },
  mounted() {
  },
  methods: {
  },
});
</script>

<style lang="scss" scoped>
.input-container {
  font-family: "SystemFont", Helvetica, Arial, sans-serif;
  display: flex;
  position: relative;
  align-items: center;
  // background-color: #0F172A;
  background: linear-gradient(45deg, rgba(15, 23, 42, 0.5), rgba(25, 39, 71, 0.5));
  padding: 4px 6px;
  gap: 5px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(8, 8, 8, .7) inset,
    0 1px 0 0 rgba(255, 255, 255, .08),
    0 1px 2px 1px rgba(8, 8, 8, .7) inset;
}

.input-container .bash-text {
  font-size: .8rem;
  color: white;
}

.input-container .bash-text .user {
  color: #E879F9;
}

.input-container .bash-text .vm {
  color: #2DD4BF;
}

.input-container .bash-text .char {
  color: #A78BFA;
}

.input-container .bash-text .value {
  background-color: transparent;
  border: none;
  outline: none;
  color: yellow;
}

.input-container .icon-inline {
  margin: 1px 0 0 1px;
  position: absolute;
  right: 10px;
  top: -6px;
  font-size: 2.2rem;
  transform: rotate(30deg);
  color: yellow;
  opacity: 0.2;
}
</style>